class JoinTheCommunitySlider {
  constructor(container) {
    this.container = container;
    this.splideInstance = null;
    this.mouseMoveListener = this.mouseMoveListener.bind(this);
    this.mouseDownListener = this.mouseDownListener.bind(this);
    this.mouseUpListener = this.mouseUpListener.bind(this);
    this.init();
  }

  init() {
    this.handleSplideSlider();
  }

  handleSplideSlider() {
    const videoSlider = this.container;

    if (videoSlider) {
      if (this.splideInstance) {
        this.splideInstance.destroy(true);
      }

      this.splideInstance = new Splide(videoSlider, {
        type: 'loop',
        perPage: 4,
        perMove: 1,
        mobileFirst: true,
        autoplay: 'play',
        arrows: false,
        padding: { left: '100px', right: '100px' },
        pagination: false,
        gap: '30px',
        speed: 1000,
        breakpoints: {
          992: {
            centerMode: true,
            perPage: 1,
            padding: { left: '75px', right: '75px' },
            variableWidth: false
          }
        }
      })

      this.progressBar = this.splideInstance.root.querySelector(
        '.join-the-community-slider-progress-bar'
      );

      this.progressBarContainer = this.splideInstance.root.querySelector(
        '.join-the-community-slider-progress'
      );

      this.splideInstance.on('mounted move', () => {
        const totalItems = this.splideInstance.Components.Elements.slides.length;
        this.progressBar.style.width = String(100 / totalItems) + '%';
        this.progressBar.style.marginLeft = (this.splideInstance.index * (100 / totalItems)) + '%';
        this.progressBar.style.transition = 'margin 500ms';
      });

      this.progressBarContainer.addEventListener('click', this.mouseMoveListener, true);
      this.progressBarContainer.addEventListener('mousedown', this.mouseDownListener, true);
      window.addEventListener('mouseup', this.mouseUpListener, true);

      this.progressBarContainer.addEventListener('touchstart', this.mouseDownListener, true);
      window.addEventListener('touchend', this.mouseUpListener, true);

      this.splideInstance.mount();
    }
  }

  mouseMoveListener(event) {
    if (!this.splideInstance) return;
    const totalItems = this.splideInstance.Components.Elements.slides.length;
    const clickX = (event.clientX || event.targetTouches[0].pageX) - this.container.offsetLeft;
    const clickXpercentage = (clickX / this.progressBarContainer.clientWidth) * 100;
    const targetItem = ((totalItems / 100) * clickXpercentage).toFixed(0) - 1;
    this.splideInstance.go(targetItem);
  }

  mouseDownListener(e) {
    window.addEventListener('mousemove', this.mouseMoveListener, true);
    window.addEventListener('touchmove', this.mouseMoveListener, true);
  }

  mouseUpListener(e) {
    window.removeEventListener('mousemove', this.mouseMoveListener, true);
    window.removeEventListener('touchmove', this.mouseMoveListener, true);
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const joinTheCommunitySection = document.querySelector('[join-the-community-slider]');

  if (joinTheCommunitySection) {
    new JoinTheCommunitySlider(joinTheCommunitySection);
  }
});

document.addEventListener('shopify:section:load', (event) => {
  const joinTheCommunitySection = event.target.querySelector('[join-the-community-slider]');

  if (joinTheCommunitySection) {
    new JoinTheCommunitySlider(joinTheCommunitySection);
  }
});
